var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 7.79492C8.9375 8.00244 8.86279 8.19336 8.70508 8.34277L2.12256 14.7842C1.98145 14.9253 1.79883 15 1.58301 15C1.15137 15 0.819336 14.6763 0.819336 14.2446C0.819336 14.0371 0.910645 13.8462 1.04346 13.7051L7.08643 7.79492L1.04346 1.88476C0.910646 1.74365 0.819337 1.56103 0.819337 1.34521C0.819337 0.913574 1.15137 0.589843 1.58301 0.589843C1.79883 0.589843 1.98145 0.66455 2.12256 0.813964L8.70508 7.24707C8.86279 7.40479 8.9375 7.5874 8.9375 7.79492Z",
    fill: "#AAB2BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.184f681dbbe581fd7b58912fdf52daa8.svg";
export { ForwardRef as ReactComponent };